import React from 'react';
import s from './ExampleWidget.module.scss';
export const ExampleWidget = _ref => {
  let {
    data: {
      foo
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: s.example
  }, /*#__PURE__*/React.createElement("div", null, "data.foo: ", foo));
};
export const EXAMPLE_WIDGET = 'EXAMPLE_WIDGET';

/** type ToolExecuteResponse.WidgetSpec (Assistant tool that respond with widget) example:
 *
 * widget: {
    widget: 'EXAMPLE_WIDGET',
    data: {
      foo: 'bar',
    }
  }
*/
//# sourceMappingURL=ExampleWidget.js.map